module.exports = __webpack_public_path__ + "static/note-b3f6f620d943253b72bfcf58a5870c5e.jpg";